import { render, staticRenderFns } from "./61.vue?vue&type=template&id=4bc42d17&scoped=true&"
var script = {}
import style0 from "./61.vue?vue&type=style&index=0&id=4bc42d17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc42d17",
  null
  
)

export default component.exports